import type { Deal } from '@/types'

export type DealsTableSortKey = 'empresa' | 'deal' | 'valor' | 'probabilidade' | 'closer' | 'proximaAcao' | 'status'
export type SortDirection = 'asc' | 'desc'

function compareString(a?: string, b?: string) {
  return (a || '').localeCompare(b || '', 'pt-BR', { sensitivity: 'base' })
}

function nextActionDateValue(deal: Deal) {
  const raw = deal.dataReuniao || deal.dataFechamentoPrevisto
  if (!raw) return Number.POSITIVE_INFINITY
  const time = new Date(raw).getTime()
  return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time
}

export function sortDealsForTable(deals: Deal[], key: DealsTableSortKey, direction: SortDirection): Deal[] {
  const factor = direction === 'asc' ? 1 : -1

  return [...deals].sort((a, b) => {
    let result = 0

    if (key === 'empresa') result = compareString(a.empresaNome, b.empresaNome)
    else if (key === 'deal') result = compareString(a.nome, b.nome)
    else if (key === 'valor') result = (a.valor || 0) - (b.valor || 0)
    else if (key === 'probabilidade') result = (a.probabilidade || 0) - (b.probabilidade || 0)
    else if (key === 'closer') result = compareString(a.closerNome, b.closerNome)
    else if (key === 'proximaAcao') result = nextActionDateValue(a) - nextActionDateValue(b)
    else if (key === 'status') result = compareString(a.etapa, b.etapa)

    return result * factor
  })
}
